export { default as iosBadge } from './appstore-tv2-play.svg';
export { default as androidBadge } from './googleplay-tv2-play.svg';
